<ng-container *transloco="let t; read:'permit.safetyRule'">
    <div class="root" *ngIf="safetyRules?.length > 0" (click)="openModal(safetyRules)">
        {{ t("safetyRule") }}&nbsp;{{ getIdsString(safetyRules) }}
    </div>
</ng-container>
